import { apiErrorText } from '~/composables/useOrders'

const DISCLOSURE_STATUSES = ['pending', 'partial', 'full', 'disclosed']

const DISCLOSURE_MODES = ['known', 'scan_at_pick', 'pool']

const DISCLOSURE_DONE = ['full', 'disclosed']

export const isDisclosureDone = (status) =>
  DISCLOSURE_DONE.includes(status)

const DISCLOSURE_STATUS_COLORS = {
  pending: 'warning',
  partial: 'warning',
  full: 'success',
  disclosed: 'success',
}

const DISCLOSURE_MODE_COLORS = {
  known: 'neutral',
  scan_at_pick: 'info',
  pool: 'primary',
}

export const useDisclosure = () => {
  const toast = useToast()
  const { t } = useI18n()

  const getOrder = async (orderUuid) => {
    if (!orderUuid) return null
    try {
      const response = await useApi(`api/disclosure/${orderUuid}`)
      return response?.data || null
    } catch (error) {
      toast.add({
        description: apiErrorText(error) || t('ui.kiz.disclosure.loadError'),
        color: 'error',
      })
      return null
    }
  }

  // Свёртка статуса раскрытия по позициям заказа/поставки (PENDING/PARTIAL/FULL).
  const rollupStatus = (items = []) => {
    const list = items.filter((item) => item && item.mode)
    if (!list.length) return null
    const disclosed = list.filter((item) => isDisclosureDone(item.status)).length
    if (disclosed === 0) return 'pending'
    if (disclosed === list.length) return 'full'
    return 'partial'
  }

  const statusColor = (status) => DISCLOSURE_STATUS_COLORS[status] || 'neutral'

  const modeColor = (mode) => DISCLOSURE_MODE_COLORS[mode] || 'neutral'

  const statusLabel = (status) => {
    if (!status) return ''
    const key = `ui.kiz.disclosure.statuses.${status}`
    const translated = t(key, undefined, { missingWarn: false })
    return translated && translated !== key ? translated : status
  }

  const modeLabel = (mode) => {
    if (!mode) return ''
    const key = `ui.kiz.disclosure.modes.${mode}`
    const translated = t(key, undefined, { missingWarn: false })
    return translated && translated !== key ? translated : mode
  }

  return {
    DISCLOSURE_STATUSES,
    DISCLOSURE_MODES,
    getOrder,
    rollupStatus,
    statusColor,
    modeColor,
    statusLabel,
    modeLabel,
    isDisclosureDone,
  }
}
